import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { AccessibleTextArea } from '../../../../../components/inputs/AccessibleTextArea';
import { StyledQuestionMark } from '../../../../../components/QuestionMark';

type ExtraInfoFieldProps = {
  value: string;
  disabled?: boolean;
  onChange: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
};

export const ExtraInfoField = ({
  value,
  disabled = false,
  onChange,
}: ExtraInfoFieldProps) => {
  return (
    <AccessibleTextArea
      id="extra_info"
      label="Extra information on journal row"
      tooltip={
        <Tooltip
          title="Extra information to be shown in each journal of this agreement"
          placement="top"
        >
          <IconButton size="small" sx={{ marginLeft: '3px' }}>
            <StyledQuestionMark fontSize="small" />
          </IconButton>
        </Tooltip>
      }
      name="extra_info"
      placeholder="Extra information"
      onChange={onChange}
      value={value}
      style={{ maxWidth: '100%' }}
      disabled={disabled}
      maxLength={400}
      rows={4}
    />
  );
};
